import { format } from 'date-fns';

import { BUILDING_TYPE, ONEROOM_TYPE, VILLA_TYPE } from '@/const/buildingType';
import { MemulItemType } from '@/service/commonType';
import { useLastFilterStore } from '@/store/lastFilterType';
import { numberToShortPrice } from '@/utils/js/number';

export default function Badge({
  itemData,
  pageCheck,
}: {
  itemData: MemulItemType;
  pageCheck?: string;
}) {
  const { lastFilterType } = useLastFilterStore();

  const handleMnexPrice = (itemData: MemulItemType) => {
    const oneroomMemulCondition =
      Object.keys(BUILDING_TYPE).includes(itemData.buildingType) &&
      itemData.meter2 <= 50 &&
      itemData.roomCount <= 2 &&
      lastFilterType === 'oneroom' &&
      pageCheck === 'memulList';

    const oneroomOtherCondition =
      Object.keys(VILLA_TYPE).includes(itemData.buildingType) &&
      Object.keys(ONEROOM_TYPE).includes(itemData.buildingType) &&
      pageCheck !== 'memulList';

    const villaCondition = Object.keys(VILLA_TYPE).includes(itemData.buildingType);

    if (
      itemData.mnexPriceDisplayYn === 'Y' &&
      (villaCondition || oneroomMemulCondition || oneroomOtherCondition)
    ) {
      if (!itemData.mnexPrice || +itemData.mnexPrice === 0) {
        return <span className="tag">관리비 없음</span>;
      } else {
        return (
          <span className="tag">
            관리비 {numberToShortPrice({ value: itemData.mnexPrice, maintenanceCost: true })}
          </span>
        );
      }
    } else return null;
  };

  return (
    <div className="tag_div">
      {itemData?.displayDate && (
        <span className="tag">{format(new Date(itemData.displayDate), 'MM.dd')} 등록</span>
      )}
      {itemData?.intoDay && <span className="tag">{itemData?.intoDay}</span>}
      {'buildingType' in itemData && handleMnexPrice(itemData)}
    </div>
  );
}
